import { takeLatest, call, put, all } from 'redux-saga/effects';
import {
  BEFORE_LOGIN_MARQUEE,
  CANCLE_NOTIFICATIONS_BY_ID,
  CREATE_NOTIFICATION, GET_ALL_NOTIFICATIONS, GET_NOTIFICATIONS_BY_ID, SEARCH_NOTIFICATION, UPDATE_NOTIFICATION,
} from '../../actionLabels/addNotification/addNotification';

import {
  createNotificationsSuccess,
  createNotificationFailure,
  createEditNotificationApiStatus,
  getAllNotifications,
  getAllNotificationsSuccess,
  getAllNotificationsFail,
  getNotificationByIdActionSuccess,
  getNotificationByIdActionFail,
  updateNotificationActionSuccess,
  updateNotificationActionFail,
  createNotificationDisable,
  searchNotificationActionSuccess,
  searchNotificationActionFail,
  NotificationLoader,
  notificationLoader,
  getBeforeLoginMarqueeActionSuccess,
  getBeforeLoginMarqueeActionFail,
  cancleNotificationByIdActionSuccess,
  cancleNotificationByIdActionFail,
} from '../../actions/addNotification/addNotification';

import axiosMain from "../../../http/axios/axios_main";
import CustomToast from '../../../components/Toast';

// Worker Saga
function* createNotificationWorker(action) {
  try {
    const response = yield call(axiosMain.post, '/admin/marquee/create', action.payload);
    console.log("action.payload", action.payload)
    console.log("action.payload response", response)
    if (response.status === 200 || response.status === 201) {
      if (response.data.statusCode === 200) {
        CustomToast.success(response.data.message);
        yield put(createNotificationDisable(true))
        yield put(createNotificationsSuccess(response.data));
        yield put(createEditNotificationApiStatus(true));

      }
      else {
        CustomToast.error(response.data.message)
        yield put(createNotificationFailure(response.data.message))
      }

    } else {
      yield put(createNotificationFailure(response.message || 'Unexpected error'));
    }
  } catch (error) {
    yield put(createNotificationFailure(error.response?.data?.message || error.message));
  }
  // yield put(createNotificationDisable(true))
}

function* getAllNotificationsWorker(action) {
  console.log("action.payload", action.payload)
  try {
    const response = yield call(axiosMain.post, `/admin/marquee/search`, action.payload);
    yield put(getAllNotificationsSuccess(response.data));
  } catch (error) {
    yield put(getAllNotificationsFail(error));
  }
}

//Fetch notification by ID
function* getNotificationByIdWorker(action) {
  try {
    const marqueeId = action.payload;
    const notificationData = yield call(axiosMain.get, `/admin/marquee/get/${marqueeId}`);

    if (notificationData.status == 200) {
      yield put(getNotificationByIdActionSuccess(notificationData.data));
    } else {
      CustomToast.error(notificationData.message);
      yield put(getNotificationByIdActionFail(notificationData.message));
    }
  } catch (error) {
    yield put(getNotificationByIdActionFail(error));
  }
}

function* cancleNotificationByIdWorker(action) {
  try {
    const marqueeId = action.payload;
    const notificationData = yield call(axiosMain.put, `/admin/marquee/cancelnotification/${marqueeId}`);

    if (notificationData.status == 200) {
      if (notificationData.data.statusCode == 200) {
        CustomToast.success(notificationData.data.message)
        yield put(cancleNotificationByIdActionSuccess(notificationData.data));
      }
      else {
        CustomToast.error(notificationData.data.message);
        yield put(cancleNotificationByIdActionFail(notificationData.data.message));
      }

    }
    else{
      yield put(cancleNotificationByIdActionFail(notificationData.data.message))
    }
  } catch (error) {
    yield put(cancleNotificationByIdActionFail(error));
  }
}

// update notification
function* updateNotificationWorker(action) {
  try {
    const { updatedNotificationData } = action.payload;

    const updatedNotification = yield call(
      axiosMain.post,
      `/admin/marquee/update`,
      updatedNotificationData
    );
    if (updatedNotification.status == 200) {
      if (updatedNotification.data.statusCode == 200) {
        CustomToast.success(updatedNotification.data.message);
        yield put(updateNotificationActionSuccess(updatedNotification));
        // yield put(searchStateAction(updatedNotificationData.searchData || {}));
        yield put(createEditNotificationApiStatus(true));
      } else {
        CustomToast.error(updatedNotification.data.message);
        console.log("updatedNotification ", updatedNotification);
        yield put(updateNotificationActionFail(updatedNotification.data.message));
      }
    } else {
      yield put(updateNotificationActionFail(updatedNotification.message));
    }
  } catch (error) {
    yield put(updateNotificationActionFail(error.message));
  }
}

//searching a notification
function* searchNotificationWorker(action) {
  try {
    const searchTerm = action.payload;
    const searchResults = yield call(
      axiosMain.post,
      `/admin/marquee/search`,
      searchTerm
    );

    if (searchResults.status == 200) {
      yield put(searchNotificationActionSuccess(searchResults.data));
      yield put(notificationLoader(true));
    } else {
      CustomToast.error(searchResults.message);
      yield put(searchNotificationActionFail(searchResults));
    }
  } catch (error) {
    yield put(searchNotificationActionFail(error));
  }
}

// get before login marquee//
function* getAllBeforeLoginMarqueeWorker() {
  try {
    const response = yield call(axiosMain.get, `admin/marquee/getBeforeLoginMarquee`);
    yield put(getBeforeLoginMarqueeActionSuccess(response.data));
  } catch (error) {
    yield put(getBeforeLoginMarqueeActionFail(error));
  }
}

// Watcher Saga
export function* watchCreateNotification() {
  yield all([
    yield takeLatest(CREATE_NOTIFICATION, createNotificationWorker),
    yield takeLatest(GET_ALL_NOTIFICATIONS, getAllNotificationsWorker),
    yield takeLatest(GET_NOTIFICATIONS_BY_ID, getNotificationByIdWorker),
    yield takeLatest(CANCLE_NOTIFICATIONS_BY_ID, cancleNotificationByIdWorker),
    yield takeLatest(UPDATE_NOTIFICATION, updateNotificationWorker),
    yield takeLatest(SEARCH_NOTIFICATION, searchNotificationWorker),
    yield takeLatest(BEFORE_LOGIN_MARQUEE, getAllBeforeLoginMarqueeWorker)
  ])
}
